export enum ScheduleStatus {
    ACTIVE = "active",
    SUSPENDED = "suspended",
    EXPIRED = "expired",
}

export enum ScheduleType {
    GENERATE_REPORTS = "GENERATE_REPORTS",
    EXTRACT_EVENTS = "EXTRACT_EVENTS",
    EXTRACT_INCIDENTS = "EXTRACT_INCIDENTS",
    EXTRACT_REFERENCE_DATA = "EXTRACT_REFERENCE_DATA",
    GENERATE_FILE = "GENERATE_FILE",
    UPDATE_REAL_TIME_COUNTER = "UPDATE_REAL_TIME_COUNTER",
}
